
import React, { useEffect, useState } from "react";
import Button from "../../common/Button/Button";
import api from "../../../services/api";
const AddAccessRoles = ({ roleId, onSubmitted, onCancel }) => {
    const id = roleId;
    const [formData, setFormData] = useState({
        role_type: "",
        remarks:""
    });

    useEffect(() => {
        if (id) {
            api.get(`/access-role/${id}`)
                .then((res) => {

                    const role = res.data;
                    if (role) {
                        setFormData({
                            role_type: role.role_type || "",
                            remarks: role.remarks || ""
                        });
                    }
                })
                .catch((err) => console.error("Error loading role:", err));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            role_type: formData.role_type,
            remarks: formData.remarks
        }

        const apiCall = id
            ? api.put(`/access-role/${id}`, payload)   
            : api.post(`/access-role`, payload);     

        apiCall
            .then(() => { if (onSubmitted) onSubmitted(); })
            .catch((error) => console.error("Error:", error));
    };

    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">


                <form onSubmit={handleSubmit} className="moduleForm">

                    <div className="formGrid">
                        <div className="formGroup">
                            <label>Role Type</label>
                            <input
                                type="text"
                                name="role_type"
                                value={formData.role_type}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="formGroup">
                            <label>Remark</label>
                            <input
                                type="text"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                                // required
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddAccessRoles;